import _ from 'lodash'
import axios from 'axios'
import { apiURL } from '@/config'
import router from '@/router'

let pagamentosRequestId = 0

const relatorios = {
  namespaced: true,
  state: {
    historico: {
      data: [],
      paginacao: {}
    },
    comparativo: {
      data: {}
    },
    pagamentos: {
      periodo_aplicado: {},
      resumo: {
        total: 0,
        valor_total: 0,
        por_status: {}
      },
      por_status: {},
      itens: []
    }
  },
  mutations: {
    INSERT_HISTORICO (state, payload) {
      if (state.historico.data.length < 1) {
        state.historico.data = payload
      } else {
        state.historico.data = _.mergeWith(state.historico.data, payload, function (a, b) {
          if (_.isArray(a)) {
            return a.concat(b)
          }
        })
      }
    },
    CLEAR_HISTORICO (state) {
      state.historico.data = []
      state.historico.paginacao = {}
    },
    SET_LISTA_PAGINACAO (state, payload) {
      state.historico.paginacao = payload
    },
    INSERT_COMPARATIVO (state, payload) {
      state.comparativo.data = payload
    },
    CLEAR_COMPARATIVO (state) {
      state.comparativo.data = {}
    },
    SET_RELATORIO_PAGAMENTOS (state, payload) {
      state.pagamentos.periodo_aplicado = payload.periodo_aplicado || {}
      state.pagamentos.resumo = payload.resumo || {
        total: 0,
        valor_total: 0,
        por_status: {}
      }
      state.pagamentos.por_status = payload.por_status || {}
      state.pagamentos.itens = payload.itens || []
    },
    CLEAR_RELATORIO_PAGAMENTOS (state) {
      state.pagamentos.periodo_aplicado = {}
      state.pagamentos.resumo = {
        total: 0,
        valor_total: 0,
        por_status: {}
      }
      state.pagamentos.por_status = {}
      state.pagamentos.itens = []
    }
  },
  actions: {
    loadHistorico ({ commit, dispatch }, payload) {
      dispatch('utils/showLoading', {}, { root: true })
      axios.get(`${apiURL}/historico`, { params: payload }).then((response) => {
        commit('INSERT_HISTORICO', response.data.data)
        commit('SET_LISTA_PAGINACAO', response.data.meta.pagination)
        dispatch('utils/hideLoading', {}, { root: true })
      }, (error) => {
        const isForbidden = error && error.response && error.response.status === 403
        dispatch('utils/showSnackbar', {
          text: isForbidden ? 'Sem permissão para visualizar relatórios.' : 'Servidor indisponível. Tente novamente mais tarde.',
          persistent: true
        }, { root: true })
        dispatch('utils/hideLoading', {}, { root: true })
        if (isForbidden) {
          router.push('/')
        }
      })
    },
    clearHistorico ({ commit }) {
      commit('CLEAR_HISTORICO')
    },
    loadComparativo ({ commit, dispatch }, payload) {
      dispatch('utils/showLoading', {}, { root: true })
      axios.get(`${apiURL}/relatorio/atual`, { params: payload }).then((response) => {
        commit('INSERT_COMPARATIVO', response.data)
        dispatch('utils/hideLoading', {}, { root: true })
      }, (error) => {
        const isForbidden = error && error.response && error.response.status === 403
        dispatch('utils/showSnackbar', {
          text: isForbidden ? 'Sem permissão para visualizar relatórios.' : 'Servidor indisponível. Tente novamente mais tarde.',
          persistent: true
        }, { root: true })
        dispatch('utils/hideLoading', {}, { root: true })
        if (isForbidden) {
          router.push('/')
        }
      })
    },
    clearComparativo ({ commit }) {
      commit('CLEAR_COMPARATIVO')
    },
    loadPagamentos ({ commit, dispatch }, payload) {
      const requestId = ++pagamentosRequestId
      dispatch('utils/showLoading', {}, { root: true })
      axios.get(`${apiURL}/relatorio/pagamentos`, { params: payload }).then((response) => {
        if (requestId !== pagamentosRequestId) return
        commit('SET_RELATORIO_PAGAMENTOS', response.data)
        dispatch('utils/hideLoading', {}, { root: true })
      }, (error) => {
        if (requestId !== pagamentosRequestId) return
        const isForbidden = error && error.response && error.response.status === 403
        dispatch('utils/showSnackbar', {
          text: isForbidden ? 'Sem permissão para visualizar relatórios.' : 'Servidor indisponível. Tente novamente mais tarde.',
          persistent: true
        }, { root: true })
        dispatch('utils/hideLoading', {}, { root: true })
        if (isForbidden) {
          router.push('/')
        }
      })
    },
    clearPagamentos ({ commit }) {
      commit('CLEAR_RELATORIO_PAGAMENTOS')
    }
  },
  getters: {
    historico (state) {
      return state.historico.data
    },
    historicoPaginacao (state) {
      return state.historico.paginacao
    },
    comparativo (state) {
      return state.comparativo.data
    },
    pagamentos (state) {
      return state.pagamentos
    }
  }
}

export default relatorios



// WEBPACK FOOTER //
// ./src/vuex/modules/relatorios.js